import { VideoData } from './VideoData';
import { VideoDataCanvas } from './VideoDataCanvas';
import { VideoResourcePool } from './VideoResourcePool';
import { Platform } from './Platform';
import { IAssetsUrlFormatter } from '../helpers/assets-url.formatter';

export class VideoResourcePoolCanvas extends VideoResourcePool {
  private _platform: Platform;

  constructor(platform: Platform, assetsUrlFormatter?: IAssetsUrlFormatter) {
    super('webgl', assetsUrlFormatter);
    this._platform = platform;
  }

  createData(video: HTMLVideoElement): VideoData {
    return new VideoDataCanvas(this._platform, video);
  }
}
